import { MobileMenuDialogMenuProps } from '@/types/props/components/layout';
import MobileMenuDialogMenuMain from './MobileMenuDialogMenuMain';
import MobileMenuDialogMenuType from './MobileMenuDialogMenuType';
import MobileMenuDialogMenuBrand from './MobileMenuDialogMenuBrand';
import MobileMenuDialogMenuCountry from './MobileMenuDialogMenuCountry';
import MobileMenuDialogMenuTopic from './MobileMenuDialogMenuTopic';
export default function MobileMenuDialogMenu({
  currentSubMenuActive,
  setCurrentSubMenuActive,
  onClose,
  setContactFormOpen,
}: MobileMenuDialogMenuProps) {
  return (
    <>
      <MobileMenuDialogMenuMain
        setCurrentSubMenuActive={setCurrentSubMenuActive}
        currentSubMenuActive={currentSubMenuActive}
        onClose={onClose}
        setContactFormOpen={setContactFormOpen}
      />
      {/* TYPE MENU */}
      <MobileMenuDialogMenuType
        setCurrentSubMenuActive={setCurrentSubMenuActive}
        currentSubMenuActive={currentSubMenuActive}
      />
      {/* BRAND MENU */}
      <MobileMenuDialogMenuBrand
        setCurrentSubMenuActive={setCurrentSubMenuActive}
        currentSubMenuActive={currentSubMenuActive}
      />
      {/* */}
      <MobileMenuDialogMenuCountry
        setCurrentSubMenuActive={setCurrentSubMenuActive}
        currentSubMenuActive={currentSubMenuActive}
      />
      <MobileMenuDialogMenuTopic
        setCurrentSubMenuActive={setCurrentSubMenuActive}
        currentSubMenuActive={currentSubMenuActive}
      />
    </>
  );
}
